module.exports.createEl = (type, options, attributes, events) => {
  const el = document.createElement(type === 'radio' || type === 'checkbox' ? 'div' : type);

  if (options) Object.keys(options).forEach((key) => {
    el[key] = options[key];
  });

  if (attributes) Object.keys(attributes).forEach((key) => {
    el.setAttribute(key, attributes[key]);
  });

  if (events) Object.keys(events).forEach((key) => {
    el.addEventListener(key, events[key]);
  });

  if (type === 'select' && options.values) {
    if (options.placeholder) {
      const label = document.createElement('option');
      label.innerText = options.placeholder;
      label.value = '';
      el.appendChild(label);
    }

    options.values.forEach((value) => {
      const option = document.createElement('option');
      option.innerText = value;
      el.appendChild(option);
    });

    el.value = options.value;
  }

  if ((type === 'ul' || type === 'ol') && options && options.values) {
    options.values.forEach((item) => {
      const li = document.createElement('li');
      li.innerText = item;
      el.appendChild(li);
    });
  }

  if (type === 'radio') {
    options.values.forEach((item, index) => {
      const input = document.createElement('input');
      const label = document.createElement('label');
      input.id = item;
      input.type = 'radio';
      input.name = options.name;
      input.value = item;
      input.checked = item === options.value;
      label.id = item;
      label.innerText = item;
      label.setAttribute('for', item);
      el.appendChild(input);
      el.appendChild(label);
      input.addEventListener('change', () => { el.setAttribute('value', item); });
    });
    if(options.value) el.setAttribute('value', options.value);
  }
  // differs from radio in that this allows multiple selections
  if (type === 'checkbox') {
    if(options.name) el.appendChild(this.createEl('p', { innerHTML: options.name }));
    options.values.forEach((item, index) => {
      const input = document.createElement('input');
      const label = document.createElement('label');
      input.id = item;
      input.type = 'checkbox';
      input.name = options.name;
      input.value = item;
      if(options.value) input.checked = options.value.indexOf(item) >= 0;
      label.id = item;
      label.innerText = item;
      label.setAttribute('for', item);
      el.appendChild(input);
      el.appendChild(label);
      input.addEventListener('change', () => {
        // TODO: rewrite with array.reduce
        let string = '';
        Array.from(el.childNodes).forEach((child) => {
          if (child.nodeName === 'INPUT' && child.checked) {
            string += `${child.value}|`;
          }
        });
        el.setAttribute('value', string.slice(0, -1));
      });
    });
    if(options.value) el.setAttribute('value', options.value.join('|'));
  }

  return el;
};

module.exports.addEl = (parent, ...children) => {
  if(children.length === 0) {
    document.body.appendChild(parent);
  } else {
    children.forEach((child) => {
      parent.appendChild(child);
    });
  }
};
